import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import Svg from './Svg';

var SvgDetectLocation = (_ref) => {
  var {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return React.createElement(Svg, _extends({
    viewBox: "0 0 16 16",
    fill: "currentcolor"
  }, props), !!title && React.createElement("title", {
    id: titleId
  }, title), React.createElement("path", {
    d: "M15.43 7.5H14A6 6 0 008.5 2V.57a.5.5 0 00-1 0V2A6 6 0 002 7.5H.57a.5.5 0 000 1H2A6 6 0 007.5 14v1.46a.5.5 0 001 0V14A6 6 0 0014 8.5h1.46a.5.5 0 000-1zM8 13a5 5 0 115-5 5 5 0 01-5 5zm0-8a3 3 0 11-3 3 3 3 0 013-3z"
  }));
};

SvgDetectLocation.isIcon = true;
SvgDetectLocation.propTypes = process.env.NODE_ENV !== "production" ? {
  title: PropTypes.string,
  titleId: PropTypes.string,
  size: PropTypes.oneOf(['xxsm', 'xsm', 'sm', 'md', 'lg']),
  tabIndex: PropTypes.number,
  focusable: PropTypes.bool,
  'aria-hidden': PropTypes.bool,
  role: PropTypes.string,
  className: PropTypes.string,
  lazyLoad: PropTypes.bool,
  rootMargin: PropTypes.string,
  threshold: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)])
} : {};
SvgDetectLocation.defaultProps = {
  size: 'md',
  tabIndex: -1,
  focusable: false,
  'aria-hidden': true,
  role: 'img',
  className: '',
  lazyLoad: true,
  threshold: 0,
  rootMargin: '48px'
};
SvgDetectLocation.displayName = 'Icon';
export default SvgDetectLocation;